import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom-v5-compat';

import { Loader } from 'src/components/Loader';
import type { User } from 'src/data/user';
import { Authentication } from 'src/lib/Authentication';
import { ROUTES } from 'src/routes';
// @ts-expect-error - no TypeScript definitions yet
import { useCurrentUser } from 'src/store/user';

import styles from './ReviewerRoute.module.scss';

interface ReviewerRouteProps {
  children: ReactNode;
}

/** A reviewer's page needs only the signed-in user: the account's customer never loads for one. */
export const ReviewerRoute = ({ children }: ReviewerRouteProps) => {
  const { pathname, search } = useLocation();
  const currentUser: User | null = useCurrentUser();

  if (!Authentication.isAuthenticated()) {
    return (
      <Navigate
        to={ROUTES.SIGN_IN}
        state={{ from: pathname + search }}
        replace
      />
    );
  }

  if (!currentUser) {
    return (
      <Loader
        className={styles.root}
        size={48}
      />
    );
  }

  return children;
};
